//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Clipboard from 'clipboard';
import { format } from 'path';
    let clipboard = new Clipboard('.copyBtn');
    export default{
        data(){
            return{
                tel:18612374027,
                people:[],
                mingwei:[[],[],[],[],[]],
                colors:['#fd413e','#ffa200','#2cfdf6','#2cacfd','#ce2cfd'],
                option : {
                    radar: [
                        {
                            indicator: [
                                { text: '水',max: 4 },
                                { text: '火',max: 4 },
                                { text: '木',max: 4 },
                                { text: '土',max: 4 },
                                { text: '金',max: 4 }
                            ],
                            radius: 110,
                            startAngle: 60,
                            splitNumber: 4,
                            shape: 'circle',
                            name: {
                                formatter:'{value}',
                                textStyle: {
                                    color:'#666'
                                }
                            },
                            splitArea: {
                                areaStyle: {
                                    color: ['#fff',
                                    '#fff', '#fff',
                                    '#fff', '#333'],
                                    shadowColor: 'rgba(0, 0, 0, 0.3)',
                                    shadowBlur: 1
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#d7d7d7'
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#eaeaea'
                                }
                            }
                        },
                    ],
                    
                    series: [
                        {
                            name: '雷达图',
                            type: 'radar',
                            itemStyle: {
                                emphasis: {
                                    // color: 各异,
                                    lineStyle: {
                                        width: 1
                                    }
                                }
                            },
                            data: [
                                {
                                    value: [],
                                    name: '图一',
                                    // symbol: 'rect',
                                    // symbolSize: 5,
                                    lineStyle: {
                                        normal: {
                                            width: '1',
                                            color:'#fd413e'
                                        }
                                    }
                                },
                                {
                                    value: [],
                                    name: '图二',
                                    // symbol: 'rect',
                                    // symbolSize: 5,
                                    lineStyle: {
                                        normal: {
                                            width: '1',
                                            color:'#ffa200'
                                        }
                                    }
                                },
                                {
                                    value: [],
                                    name: '图三',
                                    // symbol: 'rect',
                                    // symbolSize: 5,
                                    lineStyle: {
                                        normal: {
                                            width: '1',
                                            color:'#2cfdf6'
                                        }
                                    }
                                },
                                {
                                    value: [],
                                    name: '图四',
                                    // symbol: 'rect',
                                    // symbolSize: 5,
                                    lineStyle: {
                                        normal: {
                                            width: '1',
                                            color:'#2cacfd'
                                        }
                                    }
                                },
                                {
                                    value: [],
                                    name: '图五',
                                    // symbol: 'rect',
                                    // symbolSize: 5,
                                    lineStyle: {
                                        normal: {
                                            width: '1',
                                            color:'#ce2cfd'
                                        }
                                    }
                                }
                            ]
                        },
                    ]
                },
                option1 : {
                    color: ['#ffa200', '#fd413e'],
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    legend: {
                        data:['小','大'],
                        top:20
                    },
                    xAxis : [
                        {
                            type : 'category',
                            data : ['火','水','金','土','木']
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value',
                            min:0,
                            max:15
                        }
                    ],
                    series : [
                        {
                            name:'小',
                            type:'bar',
                            stack: '广告',
                            data:[1, 2, 3, 5, 4],
                        },
                        {
                            name:'大',
                            type:'bar',
                            stack: '广告',
                            data:[1, 2, 2, 0, 1]
                        },
                    ]
                }
            }
        },
        mounted(){
            this.$http.post('/wuxingMultiTestResult',{d_id:this.$route.query.id}).then(ress=>{
                let res = ress.body.result[0]
                this.people = res.nickname
                for(let m=0;m<5;m++){
                    for(let n=0;n<5;n++){
                        this.mingwei[m][n] = res.mingweiwuxing[n]?res.mingweiwuxing[n].split(',')[m]:''
                    }
                }
                
                var myChart = echarts.init(document.getElementById('fiveChart'));
                var myChart1 = echarts.init(document.getElementById('barChart'));
                this.option.radar[0].center = [(document.getElementById('fiveChart').offsetWidth/2)-12 + 'px',(document.getElementById('fiveChart').offsetHeight/2) - 2 + 'px']
                let wx = {
                    0:1,
                    1:0,
                    2:4,
                    3:3,
                    4:2
                }
                for(let p=0;p<res.rescount.length;p++){
                    for(let i = 0;i<5;i++){
                        if(res.rescount[p]){
                            this.option.series[0].data[p].value[i] = Number(res.rescount[p][wx[i]].substring(3,2)) + 1
                            this.option.series[0].data[p].value[i]>3?this.option.series[0].data[p].value[i] = 4:this.option.series[0].data[p].value[i]
                        }else{
                            this.option.series[0].data[p].value[i] = 1
                        }
                    }
                }
                console.log(this.option.series[0].data)
                for(let t = 0;t<2;t++){
                    for(let p = 0;p<5;p++){
                        this.option1.series[t].data[p] = res.BigSmall[p][t===0?1:0]
                    }
                }
                myChart.setOption(this.option);
                myChart1.setOption(this.option1);
            })
        },
        methods:{
            onCopy: function (e) {
                this.$vux.toast.text('已将内容复制到剪切板', 'center')
            },
            onError: function (e) {
                console.log('无法复制文本！')
            }
        }
        
    }



// WEBPACK FOOTER //
// ./src/components/moreResult.vue